import { z } from 'zod';
import { dataSourceKindSchema } from './data-connection-sources.js';
import { connectionProviderSchema } from './data-connections.js';

export const agentDataSourceRecordSchema = z.object({
  id: z.uuid(),
  agentId: z.coerce.number(),
  brandId: z.coerce.number().nullable(),
  dataSourceId: z.uuid(),
  isEnabled: z.boolean(),
  addedBy: z.coerce.number().nullable(),
  addedOn: z.coerce.date(),
  dataSource: z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    sourceQueryGuidance: z.string().nullable(),
    sourceIdentifier: z.string(),
    dataConnectionId: z.uuid(),
    kind: dataSourceKindSchema.optional(),
    dataConnection: z.object({
      identifier: z.uuid(),
      name: z.string(),
      connectionProvider: connectionProviderSchema.optional(),
    }),
  }),
});

export type AgentDataSourceRecord = z.infer<typeof agentDataSourceRecordSchema>;

/**
 * A data source entry derived from an agent setting rather than attached to the agent. It is
 * read-only and display-only: it is never returned by `getAgentDataSources`, so it cannot reach
 * the data agent. The agent setting named by `derivedFromFeature` is its only control.
 */
export const derivedAgentDataSourceSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  derivedFromFeature: z.string(),
  isEnabled: z.literal(true),
});

export type DerivedAgentDataSource = z.infer<typeof derivedAgentDataSourceSchema>;
